/* eslint-disable max-len */
export const FETCH_ACTIONS = 'SETTINGS:NOTIFICATIONS:FETCH_ACTIONS';
export const FETCH_ACTIONS_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_ACTIONS_SUCCESS';
export const FETCH_ACTIONS_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_ACTIONS_ERROR';

export const FETCH_TV_CONSOLES = 'SETTINGS:NOTIFICATIONS:FETCH_TV_CONSOLES';
export const FETCH_TV_CONSOLES_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_TV_CONSOLES_SUCCESS';
export const FETCH_TV_CONSOLES_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_TV_CONSOLES_ERROR';

export const FETCH_TV_ACTIONS = 'SETTINGS:NOTIFICATIONS:FETCH_TV_ACTIONS';
export const FETCH_TV_ACTIONS_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_TV_ACTIONS_SUCCESS';
export const FETCH_TV_ACTIONS_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_TV_ACTIONS_ERROR';

export const SAVE_ACTIONS = 'SETTINGS:NOTIFICATIONS:SAVE_ACTIONS';
export const SAVE_ACTIONS_SUCCESS = 'SETTINGS:NOTIFICATIONS:SAVE_ACTIONS_SUCCESS';
export const SAVE_ACTIONS_ERROR = 'SETTINGS:NOTIFICATIONS:SAVE_ACTIONS_ERROR';

export const SAVE_TV_ACTIONS = 'SETTINGS:NOTIFICATIONS:SAVE_TV_ACTIONS';
export const SAVE_TV_ACTIONS_SUCCESS = 'SETTINGS:NOTIFICATIONS:SAVE_TV_ACTIONS_SUCCESS';
export const SAVE_TV_ACTIONS_ERROR = 'SETTINGS:NOTIFICATIONS:SAVE_TV_ACTIONS_ERROR';

export const FETCH_POINTS = 'SETTINGS:NOTIFICATIONS:FETCH_POINTS';
export const FETCH_POINTS_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_POINTS_SUCCESS';
export const FETCH_POINTS_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_POINTS_ERROR';

export const TOGGLE_NOTIFICATION_POINT = 'SETTINGS:NOTIFICATIONS:TOGGLE_NOTIFICATION_POINT';
export const TOGGLE_NOTIFICATION_POINT_SUCCESS = 'SETTINGS:NOTIFICATIONS:TOGGLE_NOTIFICATION_POINT_SUCCESS';
export const TOGGLE_NOTIFICATION_POINT_ERROR = 'SETTINGS:NOTIFICATIONS:TOGGLE_NOTIFICATION_POINT_ERROR';

export const SAVE_NOTIFICATION_POINT = 'SETTINGS:NOTIFICATIONS:SAVE_NOTIFICATION_POINT';
export const SAVE_NOTIFICATION_POINT_SUCCESS = 'SETTINGS:NOTIFICATIONS:SAVE_NOTIFICATION_POINT_SUCCESS';
export const SAVE_NOTIFICATION_POINT_ERROR = 'SETTINGS:NOTIFICATIONS:SAVE_NOTIFICATION_POINT_ERROR';

export const CONFIRM_NOTIFICATION_POINT_CODE = 'SETTINGS:NOTIFICATIONS:CONFIRM_NOTIFICATION_POINT_CODE';
export const CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:NOTIFICATIONS:CONFIRM_NOTIFICATION_POINT_CODE_SUCCESS';
export const CONFIRM_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:NOTIFICATIONS:CONFIRM_NOTIFICATION_POINT_CODE_ERROR';

export const SEND_NOTIFICATION_POINT_CODE = 'SETTINGS:NOTIFICATIONS:SEND_NOTIFICATION_POINT_CODE';
export const SEND_NOTIFICATION_POINT_CODE_SUCCESS = 'SETTINGS:NOTIFICATIONS:SEND_NOTIFICATION_POINT_CODE_SUCCESS';
export const SEND_NOTIFICATION_POINT_CODE_ERROR = 'SETTINGS:NOTIFICATIONS:SEND_NOTIFICATION_POINT_CODE_ERROR';

export const TOGGLE_POINT_EDITING_STATE = 'SETTINGS:NOTIFICATIONS:TOGGLE_POINT_EDITING_STATE';

export const TOGGLE_CONFIRMATION_CODE_POPUP = 'SETTINGS:NOTIFICATIONS:TOGGLE_CONFIRMATION_CODE_POPUP';

export const RESET_NOTIFICATION_POINT_CODE_VALIDATION = 'SETTINGS:NOTIFICATIONS:RESET_NOTIFICATION_POINT_CODE_VALIDATION';

export const RESET_ERROR = 'SETTINGS:NOTIFICATIONS:RESET_ERROR';

export const CONFIRMATION_POPUP_KEY = 'SETTINGS:NOTIFICATIONS:CONFIRMATION';
export const EDITING_POPUP_KEY = 'SETTINGS:NOTIFICATIONS:EDITING';

export const FETCH_REQUEST = 'SETTINGS:NOTIFICATIONS:FETCH_REQUEST';
export const FETCH_REQUEST_SUCCESS = 'SETTINGS:NOTIFICATIONS:FETCH_REQUEST_SUCCESS';
export const FETCH_REQUEST_ERROR = 'SETTINGS:NOTIFICATIONS:FETCH_REQUEST_ERROR';

export const SAVE_REQUEST = 'SETTINGS:NOTIFICATIONS:SAVE_REQUEST';
export const SAVE_REQUEST_SUCCESS = 'SETTINGS:NOTIFICATIONS:SAVE_REQUEST_SUCCESS';
export const SAVE_REQUEST_ERROR = 'SETTINGS:NOTIFICATIONS:SAVE_REQUEST_ERROR';
